'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.threadHistoryInvariant = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _invariant = require('react-utils/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _ThreadHistory = require('../thread-history/ThreadHistory');

var _ThreadHistory2 = _interopRequireDefault(_ThreadHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var threadHistoryInvariant = exports.threadHistoryInvariant = function threadHistoryInvariant(threadHistory) {
  return (0, _invariant2.default)(threadHistory instanceof _ThreadHistory2.default, 'Expected threadHistory to be a `ThreadHistory` not a `%s`', typeof threadHistory === 'undefined' ? 'undefined' : _typeof(threadHistory));
};